import React, { useState, useEffect } from "react";

// https://api.themoviedb.org/3/genre/movie/list?api_key=<<api_key>>&language=en-US

function Genres() {
  const [genres, setGenres] = useState([]);
  const [array, setArray] = useState([]);
  
  const fetchGenres = async (url) => {
    try {
      const response = await fetch(url);
      const data = await response.json();
      const length = data.genres.length;
      setGenres(data.genres);
      setArray(Array(length).fill(false))
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchGenres(
      `https://api.themoviedb.org/3/genre/movie/list?api_key=700a119d738aa19bfa6867998fafed10`
    );
  }, []);

  return (
    <div className="filter">
      <h3 className="genres-heading">Genres</h3>
      <ul className="genres-nav">

        {genres.map((genre,i) => {
          return (
            <>
              <li
                className={
                  array[i] ? "active-genre" : ""
                }
                key={genre.id}
                onClick={()=>{
                  setArray((prev) => [...prev,array[i] = !array[i]]);
                }}
              >
                {genre.name}
              </li>
            </>
          );
        })}
      </ul>
    </div>
  );
}

export default Genres;
